import { Component, inject, OnInit }    from '@angular/core';
import { ActivatedRoute, RouterOutlet } from '@angular/router';

import { UserSession }             from '../../../api/session/session.service';
import { ListItem }                from '../../../api/ListItem';
import { DocumentsHelperUtils }    from '../../../shared/utils/documents-helper.utils';
import { PageComponent }           from '../../../shared/components/page/page.component';
import { PageTitleComponent }      from '../../../shared/components/page/title/title.component';
import { DocumentsTitleComponent } from '../../../shared/components/documents-title/documents-title.component';
import { PageContentComponent }    from '../../../shared/components/page/content/content.component';
import { NavTabsComponent }        from '../../../shared/components/page/nav-tab/nav-tab.component';
import { MatTabNavPanel }          from '@angular/material/tabs';
import { PageTitleType }           from '../../../shared/components/page/title/title';

@Component({
  selector: 'pin-documents',
  templateUrl: './documents.component.html',
  imports: [PageComponent, PageTitleComponent, DocumentsTitleComponent, PageContentComponent, NavTabsComponent, MatTabNavPanel, RouterOutlet]
})
export class DocumentsComponent implements OnInit {
  protected readonly PageTitleType = PageTitleType;
  statementsRoute = {
    id: 'StatementsTab',
    label: 'STATEMENTS',
    url: 'statements'
  };
  noticesRoute = {
    id: 'NoticesTab',
    label: 'CDARS NOTICES',
    url: 'notices'
  };
  taxDocumentsRoute = {
    id: 'TaxDocumentsTab',
    label: 'Tax Documents',
    url: 'tax-documents'
  };
  routes = [];
  userSession: UserSession;
  taxDocumentCustomers: ListItem<number>[];
  showStatements = false;
  showNotices = false;
  showTaxDocuments = false;
  private activatedRoute = inject(ActivatedRoute);

  ngOnInit() {
    this.userSession = this.activatedRoute.snapshot.data.userSession;
    this.taxDocumentCustomers = this.activatedRoute.snapshot.data.taxDocumentCustomers;
    this.showNotices = DocumentsHelperUtils.showCdarsStatements(this.userSession);
    this.showStatements = DocumentsHelperUtils.showStatements(this.userSession) || this.showNotices;
    this.showTaxDocuments = DocumentsHelperUtils.showTaxDocuments(this.userSession) && this.taxDocumentCustomers.length > 0;

    if (this.showStatements) {
      this.routes.push(this.statementsRoute);
    }

    if (this.showNotices) {
      this.routes.push(this.noticesRoute);
    }

    if (this.showTaxDocuments) {
      this.routes.push(this.taxDocumentsRoute);
    }
  }
}
